import cookieAndLocalStorage from './cookieAndLocalStorage';

const TOKEN_CHECK_INTERVAL = 30000;

class TokenChecker {
  constructor(checkTokenFunction) {
    this.checkTokenFunction = checkTokenFunction;
    this.intervalId = null;
    this.isChecking = false;
  }

  start() {
    if (this.intervalId) {
      return;
    }

    this.intervalId = setInterval(() => {
      this.checkToken();
    }, TOKEN_CHECK_INTERVAL);
  }

  stop() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  async checkToken() {
    if (this.isChecking) {
      return;
    }

    const oauth2Token = localStorage.getItem('oauth2Token');
    if (!oauth2Token) {
      return;
    }

    this.isChecking = true;

    try {
      await this.checkTokenFunction();
    } catch (error) {
      console.error('Token check failed:', error);
      cookieAndLocalStorage();
    } finally {
      this.isChecking = false;
    }
  }
}

let tokenCheckerInstance = null;

export const getTokenChecker = (checkTokenFunction) => {
  if (!tokenCheckerInstance) {
    tokenCheckerInstance = new TokenChecker(checkTokenFunction);
  }
  return tokenCheckerInstance;
};

export const startTokenChecker = (checkTokenFunction) => {
  const checker = getTokenChecker(checkTokenFunction);
  checker.start();
  return checker;
};

export const stopTokenChecker = () => {
  if (tokenCheckerInstance) {
    tokenCheckerInstance.stop();
  }
};

export default TokenChecker;




// WEBPACK FOOTER //
// ./src/helpers/TokenChecker.js